export const websiteTitle = "绝尘加速官网-不限速不限设备";

import { capitalizeFirstOfEveryWord } from '@/utils/utils'

import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import Login from "@/components/login/Login.vue" 
import Dashboard from "@/components/dashboard/Index.vue"
import Account from "@/components/Account.vue"

// Main website pages - Visitors pages
import Home from "@/components/home/Home.vue"
import Tutorials from "@/components/vpn_setup/tutorials.vue"
import WindowsDoc from "@/components/vpn_setup/windows.vue"
import AndroidDoc from "@/components/vpn_setup/android.vue"
import MacDoc from "@/components/vpn_setup/mac.vue"
import IosDoc from "@/components/vpn_setup/ios.vue"
import WindowsDoc11 from "@/components/vpn_setup/windows11.vue"

import Privacy from "@/components/pages/privacy.vue"
import Terms from "@/components/pages/terms.vue"
import Support from "@/components/pages/support.vue"
import PaymentSuccess from "@/components/pages/payment-success.vue"
import Share from "@/components/share/Share.vue"
import ShareLink from "@/components/share/ShareLink.vue"
import MyPoints from '@/components/points/MyPoints.vue';
import PointsDetails from '@/components/points/PointsDetails.vue';
import Error from '@/components/share/Error.vue';
import Withdrawal from '@/components/points/Withdrawal.vue';
import WithdrawSubmitted from '@/components/points/WithdrawSubmitted.vue';
import WithdrawHistory from '@/components/points/WithdrawHistory.vue';
import CustomFunctions from '@/components/custom_functions/custom_functions.vue'
import CustomFunctions2 from '@/components/custom_functions/custom_functions2.vue'
import Submissions from '@/components/custom_functions/Submissions.vue';
import ErrorExternalLinks from '@/components/custom_functions/ErrorExternalLinks.vue';
import Usdt from '@/components/payments/Usdt.vue'

const routes: Array<RouteRecordRaw> = [ 
  { path: '/dashboard', component: Dashboard ,meta: {title: "dashboard"}},
  { path: '/login', component: Login ,meta: {title: "login"}},
  { path: '/login', component: Login },
  { path: '/account', component: Account }, 

  { path: '/tutorials', component: Tutorials   ,meta: {title: "Tutorials 下载问题"}}, //windows
  { path: '/tutorials/windows', component: WindowsDoc   ,meta: {title: "Windows下载失败"}}, //windows
  { path: '/tutorials/android', component: AndroidDoc   ,meta: {title: "Android下载失败"}}, //android
  { path: '/tutorials/mac', component: MacDoc   ,meta: {title: "Mac下载失败"}}, //mac
  { path: '/tutorials/ios', component: IosDoc   ,meta: {title: "IOS下载失败"}}, //ios
  { path: '/tutorials/windows11', component: WindowsDoc11 , meta:{title: "Windows11下载失败"} }, //windows11

  { path: '/privacy_policy', component: Privacy   ,meta: {title: "Privacy Policy 隐私政策"}},
  { path: '/terms', component: Terms   ,meta: {title: "Terms & Conditions 服务条款"}},
  { path: '/support', component: Support   ,meta: {title: "Support 在线咨询"}},
  { path: '/payment-success/:id', component: PaymentSuccess   ,meta: {title: "Payment Success 充值绝尘币"}}, 
  { path: '/payment-success', component: PaymentSuccess   ,meta: {title: "Payment Success 充值绝尘币"}},

  { path: '/share', component: Share , meta: {title: "Share" , showShare: true,showHeader: true} },
  { path: '/share_link', component: ShareLink , meta: {title: "Share-link" , showShare: true, showHeader: true} },
  { path: '/my_points', component: MyPoints , meta: {title: "My-Points" , showShare: true, showHeader: true } },
  { path: '/points_details', component: PointsDetails, meta: {title: "Points-Details", showShare: true ,showHeader: true} },
  { path: '/error', component: Error, meta: {title: "Error", showShare: true , showHeader: true} },
  { path: '/withdrawal', component: Withdrawal, meta: {title: "withdrawal", showShare: true , showHeader: true} },
  { path: '/withdraw-success', component: WithdrawSubmitted , meta: {title:"withdraw-success", showShare:true, showHeader: true}},
  { path: '/withdrawn-history' , component: WithdrawHistory , meta: {title: "withdrawn-history", showShare:true , showHeader: true}},
  { path: '/ads-functions' , component: CustomFunctions , meta: {title: "ads-functions", showShare:true , showHeader: true}},
  { path: '/submissions' , component: Submissions , meta: {title: "submissions", showShare:true ,showHeader: false}},
  { path: '/external-links-error' , component: ErrorExternalLinks , meta: {title: "external-links-error", showShare:true ,showHeader: true}},
  { path: '/usdt' , component: Usdt , meta: {title: "USDT", showShare:false ,showHeader: false}},
  { path: '/ads-functions2' , component: CustomFunctions2 , meta: {title: "ads-functions2", showShare:true , showHeader: true}},

  { path: '/', component: Home   ,meta: {title: "首页"}}, //Home
]

const router = createRouter({ history: createWebHistory(process.env.BASE_URL), routes })
let previousRoute = null

router.beforeEach((to, from, next) => { 
  (previousRoute as any) = from.path
  document.title = capitalizeFirstOfEveryWord(to.meta.title ? `${websiteTitle} - `+to.meta.title as string : `${websiteTitle} `);
  if (to.meta.showShare === undefined) to.meta.showShare = false;
  next() 
 })

export const getPreviousRoute = () => {
  return previousRoute
}
export default router
